let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b6B6F")).then(() => parcelRequire('2FRRj'));